import { ASSETS } from "@/lib/assets";

export const AuthorityBar = () => {
  return (
    <section className="border-y border-border bg-white py-5">
      <div className="container">
        <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between">
          {/* Label */}
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground whitespace-nowrap">
            Certificados com validade legal por
          </p>

          {/* Logos */}
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-10">
            {/* Gov.br */}
            <a
              href="https://www.gov.br"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Gov.br"
              className="opacity-70 transition-opacity hover:opacity-100"
            >
              <img
                src={ASSETS.govbr}
                alt="Gov.br"
                className="h-8 w-auto object-contain"
                loading="lazy"
              />
            </a>

            <span className="hidden h-6 w-px bg-border md:block" aria-hidden />

            {/* ITI */}
            <a
              href="https://www.iti.gov.br"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instituto Nacional de Tecnologia da Informação"
              className="opacity-70 transition-opacity hover:opacity-100"
            >
              <img
                src={ASSETS.iti}
                alt="ITI — Instituto Nacional de Tecnologia da Informação"
                className="h-8 w-auto object-contain"
                loading="lazy"
              />
            </a>

            <span className="hidden h-6 w-px bg-border md:block" aria-hidden />

            {/* SoluxID — AC parceira */}
            <a
              href="https://soluxcertificados.com.br"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SoluxID — Autoridade Certificadora"
              className="opacity-70 transition-opacity hover:opacity-100"
            >
              <img
                src={ASSETS.soluxId}
                alt="SoluxID"
                className="h-7 w-auto object-contain"
                loading="lazy"
              />
            </a>
          </div>

          {/* Biz é AGR (Agente de Registro) parceiro da AC SoluxID */}
          <div className="flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5">
            <span className="inline-block h-2 w-2 rounded-full bg-success" />
            <span className="text-xs font-semibold text-primary">Parceira SoluxID — AC ICP-Brasil</span>
          </div>
        </div>
      </div>
    </section>
  );
};
